
    <div class="d-flex align-items-center mb-5" *ngIf="(operatori$ | async).length > 1">
      Filtra per operatore
      <select class="form-control w-auto ml-3"
              [ngModel]="operatoreId"
              (ngModelChange)="handleOperatoreChange($event)">
        <option *ngFor="let operatore of operatori$ | async" [ngValue]="operatore.id">
          {{ operatore.nome }}
        </option>
      </select>
    </div>
    <mwl-calendar-day-view
      [viewDate]="date"
      [events]="this.events$ | async"
      [dayStartHour]="8"
      [dayEndHour]="20"
      [hourSegmentHeight]="80"
      [hourSegments]="1"
      [tooltipAppendToBody]="false"
      (hourSegmentClicked)="onSegmentClick.emit($event)"
    ></mwl-calendar-day-view>
  